"use client";

import { c as _c } from "react/compiler-runtime";
import DropForgeNoPower from "@/components/drop-forge/DropForgeNoPower";
import type { ComponentType, ReactNode } from "react";
export function DropForgePermissionFallback(t0) {
  const $ = _c(13);
  const {
    title,
    permissionsLoading,
    hasWallet,
    hasAccess,
    titleIcon: TitleIcon,
    titleRight
  } = t0;
  if (!permissionsLoading && hasWallet && hasAccess) {
    return null;
  }
  let t1;
  if ($[0] !== TitleIcon) {
    t1 = TitleIcon ? <TitleIcon className="tw-h-8 tw-w-8 tw-flex-shrink-0" /> : null;
    $[0] = TitleIcon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== title) {
    t2 = <h1 className="tw-mb-0 tw-inline-flex tw-items-center tw-gap-3 tw-text-3xl tw-font-semibold tw-text-iron-50">{t1}{title}</h1>;
    $[2] = t1;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = titleRight ?? null;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="tw-mb-4 tw-flex tw-items-start tw-justify-between tw-gap-3">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== permissionsLoading) {
    t5 = permissionsLoading ? <p className="tw-mb-0 tw-text-iron-400">Checking permissions…</p> : <DropForgeNoPower />;
    $[8] = permissionsLoading;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="tw-px-2 tw-pb-16 tw-pt-2 lg:tw-px-6 lg:tw-pt-8 xl:tw-px-8">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}